import { render, staticRenderFns } from "./block-profile-api-keys-copy.vue?vue&type=template&id=2d0f988a&scoped=true&lang=pug"
import script from "./block-profile-api-keys-copy.vue?vue&type=script&lang=js"
export * from "./block-profile-api-keys-copy.vue?vue&type=script&lang=js"
import style0 from "./block-profile-api-keys-copy.vue?vue&type=style&index=0&id=2d0f988a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f988a",
  null
  
)

export default component.exports